import { forwardRef } from 'react'
import { SearchInputField, SearchInputFieldProps } from 'utoniq-ui'

import { Form, useForm, UseFormProps, useTranslation } from '@/core'
import { CellFrame, Organism, OrganismFrame } from '@/core/architecture'

export type SearchFormProps = {
  onSubmit: (values: SearchFormValues) => Promise<void>
}

export type SearchFormValues = {
  keyword: string
}

const schema: UseFormProps['schema'] = o => ({
  keyword: o.string().required(),
})

const defaultValues: SearchFormValues = {
  keyword: '',
}

export const SearchForm: Organism<SearchFormProps> = ({ onSubmit }) => {
  const { handleSubmit, register } = useForm<SearchFormValues>({
    schema,
    defaultValues,
  })
  return (
    <OrganismFrame sx={{ px: 5, pb: 1 }}>
      <Form onSubmit={handleSubmit(onSubmit)} sx={{ bgcolor: 'unset' }}>
        <SearchInputCell {...register('keyword')} />
      </Form>
    </OrganismFrame>
  )
}

const SearchInputCell = forwardRef(
  (props: Omit<SearchInputFieldProps, 't'>, ref) => {
    const { t } = useTranslation('artistStore')
    return (
      <CellFrame sx={{ width: '100%' }}>
        <SearchInputField {...props} ref={ref} t={t} />
      </CellFrame>
    )
  }
)
